import { defineMessages } from 'react-intl';

export const scope = 'app.containers.MSULogo';

export default defineMessages({
  defaultMSULogoAlt: {
    id: `${scope}.defaultImageAlt`,
    defaultMessage: 'Michigan State University Logo',
  },
  defaultCIASLogoAlt: {
    id: `${scope}.defaultCIASLogoAlt`,
    defaultMessage: 'CIAS Application Logo',
  },
});
